import React from 'react';
import ScTextControl from '@/components/sc-controls/form-controls/v2/sc-text-control';
import { FieldProps } from '../form-helpers';

export type FormFieldTextProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (value: string) => void;
};

function FormFieldText({ label, required, value, onChange, onBlur, error, disabled, inTable }: FormFieldTextProps) {
    return (
        <ScTextControl
            label={label}
            required={required}
            value={value ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
            onBlur={onBlur}
            error={error}
            disabled={disabled}
            maw={inTable ? '100%' : undefined}
        />
    );
}

export default React.memo(FormFieldText);
